module.exports = __webpack_public_path__ + "static/media/MJ.6be2a3f7.jpg";